import { useCallback } from 'react';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';

const useCanStartGameSession = () => {
  const { user, walletCurrency } = useCurrentUser();
  const canStartGameSession = useCallback(
    (isFunMode?: boolean) => {
      if (user && walletCurrency) {
        return true;
      }
      if (isFunMode) {
        return true;
      }
      return false;
    },
    [user, walletCurrency],
  );

  return canStartGameSession;
};

export default useCanStartGameSession;
